// extracted by mini-css-extract-plugin
export default {"container":"SectionContainer_container__dGaCv"};